import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as Objects from '@core/objects';
import * as Access from '@app/models/access';

import { LabelsRequests } from './labels.requests';

import * as fromStore from './labels.state';
import * as fromActions from './labels.actions';


@Injectable()
export class LabelsEffects {

    constructor(private actions$: Actions, private store$: Store<fromStore.Labels>, private requests: LabelsRequests) {}

    
    public searchLabels$: Observable<fromActions.LabelsActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SearchLabels>(fromActions.LabelsActionType.SearchLabels),
        switchMap((action) => {
            return this.requests.search$(action.input).pipe(
                map((labels: Objects.Label[]) => {
                    return new fromActions.SearchLabelsSuccess(labels);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.SearchLabelsError(err));
                })
            );
        })
    ));

    
    public loadCategories$: Observable<fromActions.LabelsActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadCategories>(fromActions.LabelsActionType.LoadCategories),
        switchMap((action) => {
            return this.requests.loadCategories$().pipe(
                map((categories: Objects.LabelsGroup[]) => {
                    return new fromActions.LoadCategoriesSuccess(categories);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadCategoriesError(err));
                })
            );
        })
    ));

    
    public loadAccess$: Observable<fromActions.LabelsActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadAccess>(fromActions.LabelsActionType.LoadAccess),
        switchMap((action) => {
            return this.requests.loadAccess$().pipe(
                map((access: Access.AccessLabels) => {
                    return new fromActions.LoadAccessSuccess(access);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadAccessError(err));
                })
            );
        })
    ));

    
    public addLabel$: Observable<fromActions.LabelsActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.AddLabel>(fromActions.LabelsActionType.AddLabel),
        switchMap((action) => {
            return this.requests.add$(action.name, action.category).pipe(
                map((label: Objects.Label) => {
                    return new fromActions.AddLabelSuccess(label);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.AddLabelError(err));
                })
            );
        })
    ));

}
